var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useState } from 'react';
import { apiGetListClientHotline } from '@/actions/ClientHotlineActions';
import { notifyError } from '@/helpers/action';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { isAxiosError } from '@/types/api/apiErrorTypes';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * コンサルホットライン（企業側）一覧用データを取得するカスタムフック
 */
export const useHotlineClientListFetch = (options) => {
    const { dispatch, unmountRef } = options;
    // ホットライン一覧のデータを保存
    const [hotlineList, setHotlineList] = useState(null);
    /**
     * データ取得
     */
    const fetchHotlineListBase = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            const { payload } = yield wrapDispatch(dispatch, apiGetListClientHotline({}, {}));
            if (unmountRef.current) {
                return;
            }
            setHotlineList(payload.list);
        }
        catch (e) {
            if (unmountRef.current) {
                return;
            }
            if (isAxiosError(e) && ((_a = e.response) === null || _a === void 0 ? void 0 : _a.status) !== 404) {
                notifyError();
            }
        }
    }), [dispatch, setHotlineList, unmountRef]);
    // ローディング制御
    const { callbackPromiseEvent: fetchHotlineList, doing: isLoading } = usePromiseDoingCallback({
        initialDoingState: !hotlineList,
        promiseEvent: fetchHotlineListBase,
        unmountRef,
    });
    return {
        fetchHotlineList,
        hotlineList,
        isLoading,
    };
};
